/* eslint-disable */
import Vue from 'vue'
import msgboxVue from './index.vue'
import store from '@/store';

var CONFIRM_TEXT = '确定'
var CANCEL_TEXT = '取消'
var defaults = {
  title: '提示',
  message: '',
  type: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: false,
  closeOnClickModal: true,
  inputValue: null,
  inputPlaceholder: '',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: CONFIRM_TEXT,
  cancelButtonText: CANCEL_TEXT,
  confirmButtonClass: '',
  cancelButtonClass: '',
  vipInfo: {},
  closeImg: require('../adsense/static/close.png'),
  goldMessage: {},
  restStyle: {},
  songItem: {},
  progressConfig: null,
  progressEndCallback: null,
  clickButtonConfig: null,
  cancelConfirmBtnConfig: {},
  showTopAgreement: false, // 弹窗顶部协议
  showBreathBtns: false,
  preciseCountDown: null, // 精确倒计时时长（毫秒）
  preciseBtnConfig: {
    cancelBtnImg: 'https://qncweb.ktvsky.com/20250529/vadd/2686d88f415f0ff18119d8b022870be6.png',
    confirmBtnImg: 'https://qncweb.ktvsky.com/20250529/vadd/548274f7289b6d0ea568f025051f929a.png',
    confirmBtnBreath: true, // 确认按钮是否显示呼吸动画
  },
  tabConfig: null,
  showTopAvatar: false, // 顶部用户头像
  showCursor: false, // 是否显示手指
  showScrollMessages: false, // 是否显示滚动消息
}

// 一个遍历参数的合集
var merge = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i]
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }
  return target
}

var MessageBoxConstructor = Vue.extend(msgboxVue) // 创造一个构造器，为了创建可复用组件
var currentMsg, instance
var msgQueue = []

const defaultCallback = action => {
  if (currentMsg) {
    var callback = currentMsg.callback
    if (typeof callback === 'function') {
      if (instance.showInput) {
        callback(instance.inputValue, action)
      } else {
        callback(action)
      }
    }
    if (currentMsg.resolve) {
      var $type = currentMsg.options.$type
      if ($type === 'confirm' || $type === 'prompt') {
        if (action === 'confirm') {
          if (instance.showInput) {
            currentMsg.resolve({
              value: instance.inputValue,
              action
            })
          } else {
            currentMsg.resolve(action)
          }
        } else if (action === 'cancel' && currentMsg.reject) {
          currentMsg.reject(action)
        }
      } else {
        currentMsg.resolve(action)
      }
    }
  }
}
var initInstance = function (options) {
  if (options.pageVue) {
    MessageBoxConstructor = Vue.extend(options.pageVue)
  } else {
    MessageBoxConstructor = Vue.extend(msgboxVue)
  }
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  })

  instance.callback = defaultCallback
}

var showNextMsg = function (options) {
  if (!instance) {
    initInstance(options)
  }
  if (!instance.value || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      var options = currentMsg.options
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }
      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape'].forEach(prop => {
        if (instance[prop] === undefined) {
          instance[prop] = true
        }
      })
      document.body.appendChild(instance.$el)
      Vue.nextTick(() => {
        instance.value = true
      })
    }
  }
}
var MessageBox = function (options, callback) {
  if (options.pageVue) instance = null
  if (typeof options === 'string') {
    options = {
      title: options
    }
    if (arguments[1]) {
      options.message = arguments[1]
    }
    if (arguments[2]) {
      options.type = arguments[2]
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }
  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) { // eslint-disable-line
      msgQueue.push({
        options: merge({}, defaults, MessageBox.defaults || {}, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      })
      showNextMsg(options)
    })
  } else {
    msgQueue.push({
      options: merge({}, defaults, MessageBox.defaults || {}, options),
      callback: callback
    })
    showNextMsg()
  }
}

MessageBox.setDefaults = function (options = defaults) {
  MessageBox.defaults = options
}

MessageBox.alert = function (message, title, options) { // 如果实时购买滚动条未展示，则弹窗显示期间不展示滚动条，如果滚动条已展示，则不影响滚动条
  if (!store.state.intervalShowOrderList) {
    store.commit('SET_ORDER_LIST', false)
  }
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  // 兼容onlyBtnClose参数
  const onlyBtnClose = options && options.onlyBtnClose
  
  // 确保每次调用时都重置相关配置
  const defaultOptions = {
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false,
    onlyBtnClose: !!onlyBtnClose,
    showTopAgreement: false,
    preciseCountDown: null,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
    countdownTimer: null,
    savedPreciseCountDown: null,
    countdownFinished: false,
    showBreathBtns: false,
    showTopAvatar: false,
    showCursor: false,
    restStyle: {},
  }

  return MessageBox(merge(defaultOptions, options))
}
MessageBox.close = function (reset) {
  if (!instance) return
  instance.value = false
  store.commit('SET_ORDER_LIST', true)
  msgQueue = []
  currentMsg = null
  if (reset) {
    instance = null
  }
}
export default MessageBox
export {
  MessageBox
}
